import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableVehicles from "./components/TableVehicles";


function VehiclesRegisterPage() {
    return (
        <ToastProvider>
            <Dashboard>
                <TableVehicles />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default VehiclesRegisterPage